import { render, staticRenderFns } from "./SplitListDetail.vue?vue&type=template&id=66a77a5e&scoped=true"
import script from "./SplitListDetail.vue?vue&type=script&lang=js"
export * from "./SplitListDetail.vue?vue&type=script&lang=js"
import style0 from "./SplitListDetail.vue?vue&type=style&index=0&id=66a77a5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a77a5e",
  null
  
)

export default component.exports